const generalFunc = {
  delimitNumber: (str) => {
    return (str + "").replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
      return "₦" + (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".") ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,") : b) + c;
    });
  },
  getMonthString: (value) => {
    return value === 1 ? "January"
      : value === 2 ? "Febuary"
        : value === 3 ? "Marcg"
          : value === 4 ? "April"
            : value === 5 ? "May"
              : value === 6 ? "June"
                : value === 7 ? "July"
                  : value === 8 ? "August"
                    : value === 9 ? "September"
                      : value === 10 ? "October"
                        : value === 11 ? "November"
                          : value === 12 ? "December"
                            : value;
  },
  objectSize: (obj) => {
    var size = 0,
      header;
    for (header in obj) {
      if (obj.hasOwnProperty(header)) size++;
    }
    return size;
  },
  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  firstLetterUppercase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  getCurrentYear() {
    var date = new Date();
    return date.getFullYear()
  },
  sortZones(a, b) {
    const labelOrder = ["Zone 1", "Zone 2", "Zone 3"];
    const aIndex = labelOrder.indexOf(a.label);
    const bIndex = labelOrder.indexOf(b.label);

    // If both labels are in the order list or both are not, sort alphabetically
    if ((aIndex !== -1 && bIndex !== -1) || (aIndex === -1 && bIndex === -1)) {
      return a.label.localeCompare(b.label);
    }

    // If only one label is in the order list, sort it before the other
    if (aIndex !== -1) {
      return -1;
    } else {
      return 1;
    }
  },
  /* The `generateUrlParams` function is a utility function that takes an object `body` as a parameter
  and generates a URL query string based on the key-value pairs in the object. */
  generateUrlParams(body = {}) {
    const headers = Object.keys(body)

    if (headers.length === 0) return ''
    else if (headers.length > 0) {
      let outputStr = '?'

      headers.map((header) => {

        // if value is an object
        if (typeof (body[header]) === "object") {
          const subHeaders = Object.keys(body[header])
          let subOutputStr = ''

          subHeaders.map(subHeader => {
            if (subHeader === "states") {
              subOutputStr += `${header}.State=${body[header][subHeader]}&`
            } else {
              subOutputStr += `${header}.${subHeader}=${body[header][subHeader]}&`
            }
            return null;
          })

          outputStr += subOutputStr
        } else {
          outputStr += `${header}=${body[header]}&`

        }
        return null;
      })

      if (outputStr[outputStr.length - 1] === '&') {
        return outputStr.slice(0, outputStr.length - 1)
      }

      return outputStr;
    }
  }
}

export default generalFunc;

